import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../../UI/Modal/Modal'
import Popover from '../../../../UI/Popover/Popover'
import css from './ContainerDeleteModal.module.css'
import { AppContext } from '../../../../../providers/appProvider';
import Remove from "../../../../../assets/Icon/Remove2";

const CargoDeleteModal = ({ cargoService, containerService, defaultCargo }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);

    const [isVisibleRedistribute, setIsVisibleRedistribute] = useState(false);  

    const confirmDelete = () => { 
        cargoService.remove(defaultCargo.id)
            .then((response) => {
                setIsModalOpen(false) 
                containerService.fetchList()
            })
            .catch((error) => {
                setIsModalOpen(false)
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return (
        <>
            
            <Modal key={defaultCargo.id} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>

                <div className={css.modalHead }><h3>წაშლა</h3></div> 
                <div className={ css.message } >გსურთ ავტომობილის წაშლა?</div>
                <div className={ css.buttons }>
                    <button className={ css.removeBtnYes } onClick={confirmDelete}>დიახ მსურს!</button> 
                </div> 
            </Modal>
   

            <Popover key={defaultCargo.id} placement='left' isVisiblePopover={isVisibleRedistribute} content={<> 
                    <div className={ css.message } >გსურთ ავტომობილის წაშლა?</div>
                    <div className={ css.buttons }>
                        <button className={ css.removeBtnYes } onClick={confirmDelete}>დიახ მსურს!</button> 
                    </div> 
                </>}> 
                <span className={ css.removeBtn } ><Remove/></span> 
            </Popover> 
 


        </>
    );
};

export default CargoDeleteModal;